import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { StoreContext } from "components/StoreContext";

const Footer = () => {
  const { categories } = useContext(StoreContext);
  return (
    <footer className="site__footer">
      <div className="site__footer-container">
        <div className="site__footer-container--col">
          <h2>Shop</h2>
          <ul>
            {categories.tree.map(cat => (
              <li key={cat.id}>
                <Link to={cat.path}>{cat.text}</Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="site__footer-container--col">
          <h2>Support</h2>
          <ul>
            <li>
              <Link to="/contact-us">Contact Us</Link>
            </li>
            <li>
              <Link to="/faq">Frequently Asked Questions</Link>
            </li>
          </ul>
        </div>
        <div className="site__footer-container--col">
          <h2>About HealthStream</h2>
          <ul>
            <li>
              <a
                href="https://www.healthstream.com/about-us/"
                target="_blank"
                rel="noopener noreferrer"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                href="https://www.paycomonline.net/v4/ats/web.php/jobs?clientkey=4689D9AB2F6F99AD5F352379B206FD14"
                target="_blank"
                rel="noopener noreferrer"
              >
                Careers
              </a>
            </li>
            <li>
              <a
                href="http://ir.healthstream.com/press-releases"
                target="_blank"
                rel="noopener noreferrer"
              >
                Press
              </a>
            </li>
            <li>
              <a
                href="http://ir.healthstream.com/investor-relations"
                target="_blank"
                rel="noopener noreferrer"
              >
                Investors
              </a>
            </li>
          </ul>
        </div>
        <div className="site__footer-container--col">
          <h2>Social</h2>
          <ul>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/hstmhome"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/HealthStream"
              >
                Twitter
              </a>
            </li>
            <li>
              <a
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/healthstream/"
              >
                LinkedIn
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="site__footer-container">
        <div>
          <a
            href="https://www.healthstream.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            HealthStream.com
          </a>
          <p>&nbsp;|&nbsp;</p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.healthstream.com/operational-pages/terms-of-use"
          >
            Terms of Use
          </a>
          <p>&nbsp;|&nbsp;</p>
          <a href="/purchase-terms">Purchase Terms</a>
          <p>&nbsp;|&nbsp;</p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.healthstream.com/privacy-statement"
          >
            Privacy Policy
          </a>
          <p>&nbsp;|&nbsp;</p>
          <a href="/cookie-policy">Cookie Policy</a>
        </div>
        <div>
          <p>
            &copy;
            {new Date().getFullYear()}
            &nbsp;HealthStream
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
